import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import cloneDeep from "lodash/fp/cloneDeep";
import queryString from "query-string";
import { useHistory } from "react-router-dom";

import { configDataSelector } from "../../../../services/general/selectors";
import { updateConfigData } from "../../services/actions";
import { useSearchParams } from "../../../../../../hooks/searchParams";
import { ROUTES_MAP } from "../../../../../../routes/constants";
import { CONFIG_MANAGER_LIGHT_STEPS } from "../../../../index";

const useFooterActions = (templatesList, currentTemplate) => {
    const searchParams = useSearchParams();

    const history = useHistory();
    const dispatch = useDispatch();

    const config = useSelector(configDataSelector);

    const handleClickPrevState = useCallback(
        () => {
            const newSearchResults = { ...searchParams, template_code: currentTemplate?.code || "" };

            history.push(
                `${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.one}?${queryString.stringify(newSearchResults)}`
            );
        },
        [ currentTemplate, searchParams, history ]
    );

    const handleClickNextState = useCallback(
        () => {
            history.push(
                `${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.three}?${queryString.stringify(searchParams)}`
            );
        },
        [ history, searchParams ]
    );

    const handleClickSave = useCallback(
        () => {
            const initialConfig = cloneDeep(config);
            initialConfig.templates = templatesList;

            dispatch(updateConfigData({ id: initialConfig.id, initialConfig }));
        },
        [ config, dispatch, templatesList ]
    );

    return useMemo(
        () => ({
            handleClickPrevState,
            handleClickNextState,
            handleClickSave
        }),
        [ handleClickNextState, handleClickPrevState, handleClickSave ]
    );
};

export default useFooterActions;
